<script setup lang="ts">
import KpiIcon from '@/views/icons/KpiIcon.vue';
import {ElBadge} from 'element-plus';
import {computed} from 'vue';
import {badgeOffset} from '@/base/utils.js';

const ACTIVE_CLASS: string = '!border-zzc-blue !text-zzc-blue font-semibold';

const props = defineProps({
    to: {
        type    : String,
        required: true,
    },
    name           : String,
    icon           : String,
    badgeValue     : Number,
    badgeColor     : String,
    badgeExtraValue: Number,
    badgeExtraColor: String,
    exact          : { // false: also active on child routes, for a tab that has sub-tabs
        type   : Boolean,
        default: true,
    },
});

const badgeString      = computed<string>(() =>
    props.badgeValue === -1
        ? ''
        : props.badgeValue === 0 && props.badgeExtraValue
            ? '0'
            : props.badgeValue
                ? props.badgeValue.toString()
                : '',
);
const badgeExtraString = computed<string>(() =>
    props.badgeExtraValue === -1
        ? ''
        : props.badgeExtraValue
            ? props.badgeExtraValue.toString()
            : '',
);

function myBadgeOffset(extra: boolean): [number, number] {
    return badgeOffset([0, -8], extra, props.badgeValue, props.badgeExtraValue);
}

</script>

<template>
    <router-link
        :to="to"
        class="flex items-center px-3 pt-3 pb-2 text-sm text-gray-700 whitespace-nowrap border-b-[3px] border-transparent hover:text-zzc-blue hover:border-gray-300"
        :active-class="exact ? undefined : ACTIVE_CLASS"
        :exact-active-class="exact ? ACTIVE_CLASS : undefined"
    >
        <el-badge
            :value="badgeString"
            :color="badgeColor"
            :offset="myBadgeOffset(false)"
            class="item"
            badge-class="font-normal"
        >
            <el-badge
                :value="badgeExtraString"
                :color="badgeExtraColor"
                :offset="myBadgeOffset(true)"
                class="item"
                badge-class="font-normal"
            >
                <div class="flex flex-row items-center">
                    <KpiIcon :name="icon" v-if="icon"/>
                    {{ name }}
                </div>
            </el-badge>
        </el-badge>
    </router-link>
</template>
